/*
 * Lista de los conectores registrados
 * Refactorizado: MAZ - 3-ABR-2019
 * Refactorizado: MAZ - 15-Mar-2021
 */
import API from '@/api'
import { NULLUID, Account } from '@/models'


window.$.fn.ConnectorsCollectionPage = function (hash) {

  this.XhrCollectionPage(hash);

  this.remoteUrl = function () {
    var p1 = Appl.URL.parameter(this._url, "estado", "A");
    return API.url("/conn?state=" + p1);
  };

  this.linkTo = function (o) {
    return "#conector?id=" + o.uuid;
  };

  this.fallback = function () {
    window.location.hash = "#home";
  };

  this.dictionary = function () {
    return {
      icon: "connector-icon",
      single: "conector",
      plural: "conectores",
      states: {
        "A": "Activados",
        "I": "Inactivos",
        "X": "Eliminados",
        "*": "Todos"
      },
      title: function (o) {
        return (o.title || "Conector #"+o.uuid)
      },
      descr: function (o) {
        return (
          "**" + o.computer_name + "** - " +
          o.platform_name +
          '- Registrado el **' + prettyDateTime(new Date(o.created_date)) + '**'
        )
      },
      status: function (o) {
        return (o.state_descr)
      }
    }
  }

  return this;
};


export function mountConnectorsCollectionPage() {
  window.$("#connectors-collection-page").ConnectorsCollectionPage("#conectores");
  console.log("DONE: installed ConnectorsCollectionPage to hash '#conectores'");

  setTimeout(async () => {
    const account = await API.accounts.get(NULLUID, {
      include: 'roles,defs'
    })
    console.log("Done Account.api.get()=", account)
    Account.save(account);
  }, 100);
}
